import Vue from "vue";
import Toastify from "./Toast.vue";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(Toast, {
  closeButton: false,
  icon: false,
  timeout: 5000,
  hideProgressBar: true,
});

export const showToast = (variant, message, timeout) => {
  const content = {
    component: Toastify,
    props: {
      variant: variant,
      message: message,
    },
  };

  Vue.$toast(content, {
    timeout: timeout || 5000,
    position: "top-right",
    toastClassName: "custom-toast-component",
  });
};
